if (!customElements.get('header-search-panel')) {
  customElements.define('header-search-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('#header-search-trigger');
      this.input = this.dialog.querySelector('.js-search-input');
      this.form = this.dialog.querySelector('form');
      this.discovery = this.querySelector('.search-panel__discovery');
      this.historyKey = 'atomstack-search-history-v1';
      this.trigger.addEventListener('focus', () => this.open());
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('.search-panel-trigger').addEventListener('submit', (event) => {
        event.preventDefault();
        this.open();
      });
      this.querySelector('[data-close-search]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
        const link = event.target.closest('a[data-search-term], a.js-search-link');
        if (link) this.saveHistory(link.dataset.searchTerm || this.input.value);
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      });
      this.input.addEventListener('input', () => this.updateDiscovery());
      this.form.addEventListener('submit', (event) => {
        if (!this.input.value.trim()) event.preventDefault();
        if (!event.defaultPrevented) this.saveHistory(this.input.value);
      });
      this.querySelector('[data-clear-history]')?.addEventListener('click', () => {
        try { localStorage.removeItem(this.historyKey); } catch (_) { /* Storage may be unavailable. */ }
        this.renderHistory([]);
        this.input.focus();
      });
      this.dialog.querySelector('.js-search-reset').addEventListener('click', () => {
        this.input.value = '';
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.focus();
      });
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.close();
    }

    open() {
      if (this.closing || this.dialog.open) return;
      this.renderHistory(this.readHistory());
      this.updateDiscovery();
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('search-panel-open');
      this.input.focus();
    }

    close() {
      this.closing = true;
      this.dialog.querySelector('predictive-search')?.close();
      this.dialog.close();
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('search-panel-open');
      if (this.isConnected) this.trigger.focus({ preventScroll: true });
      this.closing = false;
    }

    updateDiscovery() {
      this.discovery.hidden = Boolean(this.input.value.trim());
      if (!this.discovery.hidden) this.dialog.querySelector('predictive-search')?.close();
      this.dialog.querySelector('.js-search-reset').hidden = !this.input.value.length;
    }

    readHistory() {
      if (this.dataset.historyEnabled !== 'true') return [];
      try {
        const entries = JSON.parse(localStorage.getItem(this.historyKey) || '[]');
        return Array.isArray(entries) ? entries.filter((term) => typeof term === 'string' && term.trim()).slice(0, 8) : [];
      } catch (_) { return []; }
    }

    saveHistory(value) {
      const term = value.trim().slice(0, 120);
      if (!term || this.dataset.historyEnabled !== 'true') return;
      const entries = [term, ...this.readHistory().filter((item) => item.toLowerCase() !== term.toLowerCase())].slice(0, 8);
      try { localStorage.setItem(this.historyKey, JSON.stringify(entries)); } catch (_) { /* Search still works without storage. */ }
      this.renderHistory(entries);
    }

    renderHistory(entries) {
      const section = this.querySelector('[data-search-history]');
      if (!section) return;
      const list = section.querySelector('[data-history-list]');
      list.replaceChildren(...entries.map((term) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        const url = new URL(this.form.action, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('options[prefix]', 'last');
        link.href = url.href;
        link.textContent = term;
        link.dataset.searchTerm = term;
        item.append(link);
        return item;
      }));
      section.hidden = !entries.length;
    }
  });
}
